<div class="cw-dialog">
    <!-- Header -->
    <div class="cw-flex-row cw-popup-title">
        <h2>
            {{ 'SHARED.POPUP.SCHEDULING.HEADER' | translate }} {{ 'GENERAL.CALENDARWEEK' | translate }} {{ weekNumber }}
        </h2>

        <!--
        <phscw-toolbar
            componentIdentifier="institutions-data"
            [componentConnection]="$any(this)"
            [buttonClose]="true">
        </phscw-toolbar>
-->

        <!-- Close-Button -->
        <span class="icon-close cw-toolbar-icon cw-popup-close" (click)="clickClose()"> </span>
    </div>

    <!-- Eingabefelder -->
    <div class="cw-flex-row">
        <phscw-input-date
            [editMode]="true"
            name="start_date"
            inputId="start_date"
            [disabled]="loading || saving"
            [(ngModel)]="startDate"
            (clickEvent)="updateWeek(startDate)"></phscw-input-date>
        <phscw-input-date
            [editMode]="true"
            label="{{ 'GENERAL.UNTIL' | translate }}"
            name="end_date"
            inputId="end_date"
            [disabled]="loading || saving"
            [(ngModel)]="endDate"
            (clickEvent)="updateWeek(endDate)"></phscw-input-date>
    </div>

    <!-- Grid -->
    <phscw-grid
        #gridSchedulingList
        gridId="schedulingList"
        [simpleGrid]="true"
        [gridColumns]="gridColumns"
        [gridDisplayedColumns]="gridDisplayedColumns"
        [gridData]="gridData"
        [saving]="loading || saving">
    </phscw-grid>

    <div [ngClass]="loading || saving ? 'icon-spinner icon-spin' : ''"></div>
</div>
